import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { CompositeProductsListComponent } from './list/list.component';
import { CompositeProductEditComponent } from './edit/edit.component';
import { CompositeProductModel, HxProductInfoService } from 'hx-services';

const compositeProductResolveFn: ResolveFn<CompositeProductModel> = route => inject(HxProductInfoService).getCompositeProductById(Number(route.paramMap.get('id')));

export const compositeProductsRoutes: Routes = [
  {
    path: '', component: CompositeProductsListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'sections', loadComponent: () => import('./sections/sections.component').then(m => m.CatalogSectionsComponent),
    data: {
      breadcrumb: 'Sections'
    }
  },
  {
    path: 'labels', loadComponent: () => import('./labels/labels.component').then(m => m.CatalogLabelsComponent),
    data: {
      breadcrumb: 'Labels'
    }
  },
  {
    path: 'uncovered', loadComponent: () => import('./uncovered/uncovered.component').then(m => m.CatalogUncoveredComponent),
    data: {
      breadcrumb: 'Uncovered'
    }
  },
  {
    path: 'new', component: CompositeProductEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: CompositeProductEditComponent,
    resolve: {
      product: compositeProductResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
